module.exports = __webpack_public_path__ + "static/media/scroll-down.582cb082.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/new/scroll-down.png
// module id = 726
// module chunks = 0